import { render, staticRenderFns } from "./HyunNamsu.vue?vue&type=template&id=0f05c164&scoped=true"
import script from "./HyunNamsu.vue?vue&type=script&lang=js"
export * from "./HyunNamsu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05c164",
  null
  
)

export default component.exports